import { FadeUp } from "@/components/site/Reveal";
import { MEDIA } from "@/lib/assets";

const MATERIALS = [
  { name: "FBB / SBS", grade: "Virgin board", spec: "Folding box board & solid bleached sulphate for premium cartons", img: MEDIA.boardStacks },
  { name: "C2S Coated", grade: "Coated two sides", spec: "Crisp, high-gloss print surface for premium branding", img: MEDIA.reelCutting },
  { name: "Recycled Grey Back", grade: "Recycled fibre", spec: "Cost-effective duplex board with grey reverse", img: MEDIA.rollStacks },
  { name: "Recycled White Back", grade: "Recycled fibre", spec: "Duplex board with a clean white reverse for a premium look", img: MEDIA.cutSheets },
];

export const Materials = () => {
  return (
    <section id="materials" data-testid="materials-section" className="bg-background pb-28 md:pb-40">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <FadeUp>
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
            <div>
              <p className="font-mono2 text-xs uppercase tracking-[0.3em] text-primary mb-6">/ Materials</p>
              <h2 className="font-display text-5xl md:text-7xl leading-[0.95]">Grades we supply</h2>
            </div>
            <p className="text-muted-foreground max-w-sm">
              A curated portfolio of paper and paperboard grades, quality-checked and ready for your production line.
            </p>
          </div>
        </FadeUp>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-border border border-border">
          {MATERIALS.map((m, i) => (
            <FadeUp key={m.name} delay={i * 0.08}>
              <div className="group bg-card h-full" data-testid={`material-card-${i}`}>
                <div className="overflow-hidden aspect-[4/5]">
                  <img
                    src={m.img}
                    alt={m.name}
                    className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-[transform,filter] duration-700 ease-out"
                  />
                </div>
                <div className="p-6">
                  <span className="font-mono2 text-[11px] uppercase tracking-[0.2em] text-primary">{m.grade}</span>
                  <h3 className="font-display text-2xl mt-2">{m.name}</h3>
                  <p className="text-sm text-muted-foreground mt-3">{m.spec}</p>
                </div>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
};
